// Package Imports
// import { GroupOutlined } from '@ant-design/icons';
import ModuleIdentifierConst from 'core/common/moduleIdentifier';

// Project Imports
import resourceName from 'core/common/resourceName';
import ResourceItem from 'interfaces/resource';

const organizationIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="size-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z"
    />
  </svg>
);
const OrganizationResource: ResourceItem = {
  name: resourceName.organization,
  identifier: ModuleIdentifierConst.ORGANISATION,
  list: `${resourceName.organization}`,
  show: `${resourceName.organization}/show/:id`,
  create: `${resourceName.organization}/create`,
  edit: `${resourceName.organization}/edit/:id`,
  options: {
    label: 'Organization',
    icon: organizationIcon,
  },

  meta: {
    dataProviderName: 'organizationDataProvider',
  },
};

export default OrganizationResource;
